(function ($) {
    $.validator.setDefaults({
        errorElement: "div",
        errorClass: "invalid-feedback",
        focusInvalid: false,
        //submitOnKeyPress: true,
        ignore: ':hidden:not([class~="input-spinner-initialized"], [class~="selectized"], .k-numerictextbox input, .k-combobox input, .validate-required, [data-validate-required="true"]), :hidden > .selectized:not(.validate-required, [data-validate-required="true"]), .selectize-control .selectize-input input, .validate-ignored',
        highlight: function (element) {
            //$(element).addClass("is-invalid")
            const $element = $(element);
            if ($element.is(".input-spinner-initialized")) {
                if ($element.css("display") == "none") {
                    $element.addClass("is-invalid");
                }
            } else if ($element.is("[data-intl-tel-input-id]")) {
                $element.parent().addClass("is-invalid");
                $element.addClass("is-invalid");
            } else if ($element.hasClass("selectized")) {
                $element.next(".selectize-control").addClass("is-invalid");
            } else {
                $element.closest(".form-control").addClass("is-invalid");
            }
        },

        unhighlight: function (element) {
            //$(element).removeClass("is-invalid");
            const $element = $(element);
            if ($element.is(".input-spinner-initialized")) {
                if ($element.css("display") == "none") {
                    $element.removeClass("is-invalid");
                }
            } else if ($element.is("[data-intl-tel-input-id]")) {
                $element.parent().removeClass("is-invalid");
                $element.removeClass("is-invalid");
            } else if ($element.hasClass("selectized")) {
                $element.next(".selectize-control").removeClass("is-invalid");
            } else {
                $(element).closest(".form-control").removeClass("is-invalid");
            }
        },

        errorPlacement: function ($error, $element) {
            if ($element.data("error-placement-container")) {
                $($element.data("error-placement-container")).append($error);
            } else if ($element.is(".input-spinner-initialized")) {
                if ($element.css("display") == "none") {
                    $error.appendTo($element.parent());
                }
            } else if ($element.is("[data-intl-tel-input-id]")) {
                $error.insertAfter($element.parent());
            } else if ($element.parent().closest(".input-group").length === 1) {
                $error.insertAfter($element.parent().closest(".input-group"));
            } else if ($element.parent().closest(".form-control").length === 1) {
                $error.insertAfter($element.parent().closest(".form-control"));
            } else if ($element.hasClass("selectized")) {
                $error.insertAfter($element.next(".selectize-control"));
            } else if ($element.closest(".input-icon").length === 1) {
                $error.insertAfter($element.closest(".input-icon"));
            } else {
                $error.insertAfter($element);
            }
        },

        success: function ($label, element) {
            $label.closest(".form-group").removeClass("has-danger");
            $label.remove();
        },

        submitHandler: function (form) {
            $(form).find(".alert-danger").hide();
        },

        invalidHandler: function (event, validator) {
            const errors = validator.numberOfInvalids();
            if (errors) {
                setTimeout(function () {
                    const $firstInvalidElement = $(validator.errorList[0].element);

                    if ($firstInvalidElement[0].selectize) {
                        $firstInvalidElement[0].selectize.focus();
                    } else if ($firstInvalidElement.is(".input-spinner-initialized")) {
                        $("input", $firstInvalidElement.next(".input-spinner-container")).focus();
                    } else if ($firstInvalidElement.data("role") === "numerictextbox") {
                        // kendo numeric textbox
                        $firstInvalidElement.prev("input").focus();
                    } else if ($firstInvalidElement.data("role") === "combobox") {
                        // kendo combobox
                        $(`input[name="${$firstInvalidElement.attr("id")}_input"]`, this).focus();
                    } else {
                        $firstInvalidElement.focus();
                    }
                }, 200);
            }
        }
    });

    $.validator.addMethod("notequal", function (value, element, param) {
        return this.optional(element) || value != $(param).val();
    }, app.localize("Validation.NotEqual"));

    $.validator.addMethod("email", function (value, element) {
        return !value || /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
    }, app.localize("Validation.EmailAddress"));

    $.validator.addMethod("text", function (value, element) {
        return (new RegExp($(element).attr("pattern"))).test(value);
    }, "Please enter a well formatted value.");

    $.validator.addMethod("phone", function (value, element, params) {
        return this.optional(element) || window.intlTelInput.getInstance(element).isValidNumber();
    }, app.localize("Validation.PhoneNumber"));

    $.validator.addMethod("mobilephone", function (value, element, params) {
        return this.optional(element) || (window.intlTelInput.getInstance(element).isValidNumber() && (window.intlTelInput.getInstance(element).getNumberType() === intlTelInput.utils.numberType.MOBILE || window.intlTelInput.getInstance(element).getNumberType() === intlTelInput.utils.numberType.FIXED_LINE_OR_MOBILE));
    }, app.localize("Validation.MobilePhoneNumber"));

    $.validator.addMethod("date", function (value, element, params) {
        return this.optional(element) || window.moment($(element).val(), abp.dateTimeFormatter.getShortDateFormat()).isValid();
    }, app.localize("Validation.Date", `<strong>${abp.dateTimeFormatter.getShortDateFormat().replace(/\[/g, "").replace(/\]/g, "")}</strong>`));

    $.validator.addMethod("number-greaterthan", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisNumber = parseFloat(typeof (value) === "string" ? value.replace(/,/g, "") : value);

        let otherNumberString;
        const $params = $(params);
        if ($params.length > 0) {
            otherNumberString = $params.val();
        } else {
            otherNumberString = params;
        }
        const otherNumber = parseFloat(typeof (otherNumberString) === "string" ? otherNumberString.replace(/,/g, "") : otherNumberString);

        return this.optional(element) || thisNumber > otherNumber;
    }, $.validator.format(app.localize("Validation.NumberGreaterThan")));

    $.validator.addMethod("number-greaterthanequalto", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisNumber = parseFloat(typeof (value) === "string" ? value.replace(/,/g, "") : value);

        let otherNumberString;
        const $params = $(params);
        if ($params.length > 0) {
            otherNumberString = $params.val();
        } else {
            otherNumberString = params;
        }
        const otherNumber = parseFloat(typeof (otherNumberString) === "string" ? otherNumberString.replace(/,/g, "") : otherNumberString);

        return this.optional(element) || thisNumber >= otherNumber;
    }, $.validator.format(app.localize("Validation.NumberGreaterThanEqualTo")));

    $.validator.addMethod("number-lessthan", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisNumber = parseFloat(typeof (value) === "string" ? value.replace(/,/g, "") : value);

        let otherNumberString;
        const $params = $(params);
        if ($params.length > 0) {
            otherNumberString = $params.val();
        } else {
            otherNumberString = params;
        }
        const otherNumber = parseFloat(typeof (otherNumberString) === "string" ? otherNumberString.replace(/,/g, "") : otherNumberString);

        return this.optional(element) || thisNumber < otherNumber;
    }, $.validator.format(app.localize("Validation.NumberLessThan")));

    $.validator.addMethod("number-lessthanequalto", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisNumber = parseFloat(typeof (value) === "string" ? value.replace(/,/g, "") : value);

        let otherNumberString;
        const $params = $(params);
        if ($params.length > 0) {
            otherNumberString = $params.val();
        } else {
            otherNumberString = params;
        }
        const otherNumber = parseFloat(typeof (otherNumberString) === "string" ? otherNumberString.replace(/,/g, "") : otherNumberString);

        return this.optional(element) || thisNumber <= otherNumber;
    }, $.validator.format(app.localize("Validation.NumberLessThanEqualTo")));

    $.validator.addMethod("date-greaterthan", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisDate = window.moment($(element).val(), abp.dateTimeFormatter.getShortDateFormat());
        if (!thisDate.isValid()) {
            // if the date format of the input is not a valid date, just return true and let the other validation method (date) to validate it
            return true;
        }

        let otherDate = window.moment(params, abp.dateTimeFormatter.getShortDateFormat());
        if (!otherDate.isValid()) {
            otherDate = window.moment($(params).val(), abp.dateTimeFormatter.getShortDateFormat());

            if (!otherDate.isValid()) {
                return false;
            }
        }

        return this.optional(element) || thisDate > otherDate;
    }, $.validator.format(app.localize("Validation.DateGreaterThan")));

    $.validator.addMethod("date-greaterthanequalto", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisDate = window.moment($(element).val(), abp.dateTimeFormatter.getShortDateFormat());
        if (!thisDate.isValid()) {
            // if the date format of the input is not a valid date, just return true and let the other validation method (date) to validate it
            return true;
        }

        let otherDate = window.moment(params, abp.dateTimeFormatter.getShortDateFormat());
        if (!otherDate.isValid()) {
            otherDate = window.moment($(params).val(), abp.dateTimeFormatter.getShortDateFormat());

            if (!otherDate.isValid()) {
                return false;
            }
        }

        return this.optional(element) || thisDate >= otherDate;
    }, $.validator.format(app.localize("Validation.DateGreaterThanEqualTo")));

    $.validator.addMethod("date-lessthan", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisDate = window.moment($(element).val(), abp.dateTimeFormatter.getShortDateFormat());
        if (!thisDate.isValid()) {
            // if the date format of the input is not a valid date, just return true and let the other validation method (date) to validate it
            return true;
        }

        let otherDate = window.moment(params, abp.dateTimeFormatter.getShortDateFormat());
        if (!otherDate.isValid()) {
            otherDate = window.moment($(params).val(), abp.dateTimeFormatter.getShortDateFormat());

            if (!otherDate.isValid()) {
                return false;
            }
        }

        return this.optional(element) || thisDate < otherDate;
    }, $.validator.format(app.localize("Validation.DateLessThan")));

    $.validator.addMethod("date-lessthanequalto", function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        const thisDate = window.moment($(element).val(), abp.dateTimeFormatter.getShortDateFormat());
        if (!thisDate.isValid()) {
            // if the date format of the input is not a valid date, just return true and let the other validation method (date) to validate it
            return true;
        }

        let otherDate = window.moment(params, abp.dateTimeFormatter.getShortDateFormat());
        if (!otherDate.isValid()) {
            otherDate = window.moment($(params).val(), abp.dateTimeFormatter.getShortDateFormat());

            if (!otherDate.isValid()) {
                return false;
            }
        }

        return this.optional(element) || thisDate <= otherDate;
    }, $.validator.format(app.localize("Validation.DateLessThanEqualTo")));

    $.validator.addMethod("time", function (value, element, params) {
        return this.optional(element) || window.moment($(element).val(), abp.dateTimeFormatter.getShortTimeFormat()).isValid();
    }, app.localize("Validation.Time", `<strong>${abp.dateTimeFormatter.getShortTimeFormat().replace(/\[/g, "").replace(/\]/g, "")}</strong>`));

    $.validator.addMethod("datetime", function (value, element, params) {
        return this.optional(element) || window.moment($(element).val(), `${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`).isValid();
    }, app.localize("Validation.DateTime", `<strong>${`${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`.replace(/\[/g, "").replace(/\]/g, "")}</strong>`));

    $.validator.addMethod("duration.time", function (value, element, params) {
        return this.optional(element) || ($("input.duration-input", $(element).closest(".duration-container")).val() && $("input.duration-input", $(element).closest(".duration-container")).val() != "00:00:00");
    }, "");
})(jQuery);
